define([
	"dojo/_base/declare",
	"dijit/CheckedMenuItem",
	"csi/view/ToolbarPlugin"
], function(declare,CheckedMenuItem,ToolbarPlugin) {

	return declare([CheckedMenuItem, ToolbarPlugin], {
		// Boolean: if true, then checked items cannot be unchecked - kind of like radio-button behavior
		//bDisableChecked: false,

		// Function: function to determine checked state returning boolean
		//testCheckedFunction: function(/*Context?*/) {},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: checked will be true if
			this.inherited(arguments);

			if (this.testCheckedFunction) {
				var	b = ctx && this.testCheckedFunction(ctx);

				this.set("checked", !!b);

				if (b && this.bDisableChecked) {
					this.set("disabled", true);
				}
			} 
		},

		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		onClick: function(/*Event*/e, /*Action*/action) {
		    // summary: don't invoke an action onClick as it was invoked in onChange handler
		}
	});
});